import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { LANGS } from "../utils/constants";

/**
 * Language selector
 *
 * @param {{ showLabelWhenClosed?: boolean }} props
 *        • showLabelWhenClosed = true  → button shows "🇬🇧 English (UK)"
 *        • showLabelWhenClosed = false → button shows "🇬🇧"   (default)
 */
export default function LangSwitcher({ showLabelWhenClosed = false }) {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  const current =
    LANGS.find((l) => l.code === i18n.resolvedLanguage) || LANGS[0];

  /** Change language and close pop-up */
  const choose = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className="relative h-full">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="small-outlined-button !h-full whitespace-nowrap"
        aria-label="Change language"
        aria-expanded={open}
      >
        {current.flag} {showLabelWhenClosed && current.label}
      </button>

      {open && (
        <ul className="absolute left-0 z-50 mt-1 flex min-w-[9rem] flex-col overflow-hidden rounded border bg-white shadow md:left-auto md:right-0">
          {LANGS.map(({ code, label, flag }) => (
            <li key={code}>
              <button
                type="button"
                onClick={() => choose(code)}
                className="flex w-full items-center gap-2 px-3 py-1.5 text-left hover:bg-gray-100"
              >
                <span className="text-lg">{flag}</span>
                <span>{label}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
